import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { PhotoSlot } from '../ui/PhotoSlot';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  const reduce = useReducedMotion();
  const enter = (delay: number) => ({
    initial: {
      opacity: 0,
      y: reduce ? 0 : 18
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease: EASE,
      delay
    }
  });
  return <section id="top" aria-labelledby="hero-heading" className="hero-bg relative isolate overflow-hidden text-white" data-id="element-130" data-mp="mrxzs7jp00qf">
      <div aria-hidden="true" className="hero-glow pointer-events-none absolute -z-10 right-[-12vw] top-1/2 aspect-square w-[75vw] -translate-y-1/2 lg:w-[55vw]" data-id="element-131" data-mp="vmccq3gr2z6d" />
      <div className="px-fluid grid min-h-[calc(100svh-var(--header-h)-2.5rem)] items-center gap-fluid py-[clamp(3.5rem,7vw,9rem)] lg:grid-cols-12" data-id="element-132" data-mp="10njhruridk9c">
        <div className="lg:col-span-7" data-id="element-133" data-mp="1aitjsihwprn4">
          <motion.h1 {...enter(0.06)} id="hero-heading" className="text-[clamp(1.8rem,0.8rem+3.15vw,6rem)] font-extrabold leading-[1.08] tracking-[-0.025em]" data-id="element-134" data-mp="1ahijisno720r">
            <span className="block text-brand-accent" data-id="element-135" data-mp="4qsqdd3q2yli">Empowering...</span>
            <span className="block" data-id="element-136" data-mp="3vvj4a4oqzip0">Business Owners</span>
            <span className="block" data-id="element-137" data-mp="3rtxjzy9vw24s">Teams</span>
            <span className="block" data-id="element-138" data-mp="3rv8nry3bx9vw">Individuals</span>
            <span className="block text-brand-accent" data-id="element-139" data-mp="setvsd5ltywp">&amp; You</span>
            <span className="block text-[0.72em] font-light leading-[1.3] tracking-[-0.01em]" data-id="element-140" data-mp="sg4zkcz1v6nt">is what drives me.</span>
          </motion.h1>
          <motion.p {...enter(0.12)} className="text-lead mt-[clamp(1.5rem,2.4vw,3rem)] max-w-[44ch] text-white/85" data-id="element-141" data-mp="inpl3pmyp07o">
            30 years in marketing. Deep in automation and AI. I help business owners streamline the work, grow
            revenue, and believe in what’s possible.
          </motion.p>
          <motion.div {...enter(0.18)} className="mt-[clamp(2rem,3vw,3.5rem)] flex flex-wrap gap-4" data-id="element-142" data-mp="16csa5ijxdvc7">
            <a href="#consulting" className="btn group bg-white text-brand-navy hover:shadow-[0_10px_30px_-10px_rgba(1,159,254,0.7)]" data-id="element-143" data-mp="30mp81hgyw2le">
              Work With Me
              <ArrowRightIcon className="h-[1.1em] w-[1.1em] transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-144" data-mp="2qu1ecvlaaeqw" />
            </a>
            <a href="#speaking" className="btn border-2 border-white/60 text-white hover:border-white hover:bg-white/10" data-id="element-145" data-mp="2muive5d0wdqp">
              Book Me to Speak
            </a>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: reduce ? 1 : 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="lg:col-span-5" data-id="element-146" data-mp="2cwcwzxqfdpql">
          <PhotoSlot src="https://assets.cdn.filesafe.space/CsfHedhhmiHrpQT8qQjB/media/6ade8d61d542268bb42b529f.png" priority tone="dark" alt="Portrait of David Moceri" label="Portrait · 4:5" className="radius-fluid aspect-[4/5] max-h-[80svh] lg:aspect-auto lg:h-[clamp(30rem,70svh,68rem)]" data-id="element-147" data-mp="b3x2r56s9ngq" />
        </motion.div>
      </div>
    </section>;
}